import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { conf } from '../../../../confg';
import NumberFormat from 'react-number-format';
import { height } from '@fortawesome/free-solid-svg-icons/faEdit';
import useProductCard from '../../../marketPlace/hooks/useProductCard';
// import './ProductCard.css';
import { Link } from 'react-router-dom';

const ProductCard = ({ product, index, isTeammate, translate }) => {
  const weight = parseFloat(product.products?.accounting_weight || 0).toFixed(3);
  const { discounted, product_price_without, productUrl } = useProductCard({
    product,
    // gold,
  });

  console.log({ productUrl });
  const productName = product.products?.accounting_name_product || 'نامشخص';
  const productId = product.products?.id || index + 1;
  const imageUrl = product.pictures?.[0]?.url ? `${conf.product_image_url}${product.pictures[0].url}?width=120&height=150` : '';

  return (
    <Link target='_blank' to={productUrl} className='product-content-confirm' style={{ textDecoration: 'none', color: 'inherit' }}>
      <div className='product-card-info' style={cardStyles.container}>
        <div className='p-0' style={cardStyles.body}>
          <Row className='align-items-center no-gutters' style={cardStyles.row}>
            {/* Product Image */}
            <Col xs={4} md={3} style={cardStyles.imageCol}>
              <div style={cardStyles.imageContainer}>
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={`تصویر ${productName}`}
                    style={cardStyles.image}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                ) : (
                  <div style={cardStyles.noImage}>
                    <span style={cardStyles.noImageText}>بدون تصویر</span>
                  </div>
                )}
              </div>
            </Col>

            {/* Product Info */}
            <Col xs={8} md={9} style={cardStyles.infoCol}>
              <div style={cardStyles.productInfo}>
                <div style={cardStyles.productDetails}>
                  <h6 style={cardStyles.productName}>{productName}</h6>

                  {/* Product Code - Hidden for now */}
                  {/* <div style={cardStyles.productCode}>
                    <span>کد: {productId}</span>
                  </div> */}

                  {/* Weight Info */}
                  {isTeammate ? (
                    <div style={cardStyles.weightContainer}>
                      <span style={cardStyles.weightBadge}>
                        <span style={cardStyles.weightValue}>{weight}</span>
                        <span style={cardStyles.weightUnit}> {translate('weight-unit')}</span>
                      </span>
                    </div>
                  ) : (
                    <div style={cardStyles.weightInfo}>
                      <span style={cardStyles.weightText}> {parseFloat(weight).toFixed(1)} گرم</span>
                    </div>
                  )}
                  {discounted && (
                    <div className='discount-tag-container'>
                      <span className='discount-tag'>{product['discount']['percent']}% تخفیف</span>
                    </div>
                  )}
                  {!isTeammate && (
                    <div style={cardStyles.priceContainer}>
                      <div style={cardStyles.priceWrapper}>
                        <NumberFormat value={(product.final_price || 0) / 10} displayType='text' thousandSeparator={true} style={cardStyles.priceValue} />
                        <span style={cardStyles.priceUnit}> تومان</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Price Section - Only for customers */}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Link>
  );
};

// Inline Styles
const cardStyles = {
  container: {
    width: '100%',
    // border: '1px solid #e9ecef',
    // borderRadius: '12px',
    backgroundColor: '#ffffff',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    overflow: 'hidden',
    ':hover': {
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)',
    },
  },

  body: {
    padding: '16px',
  },

  row: {
    margin: '0',
    minHeight: '100px',
  },

  imageCol: {
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  imageContainer: {
    width: '100%',
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    overflow: 'hidden',
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
    transition: 'transform 0.3s ease',
    ':hover': {
      transform: 'scale(1.05)',
    },
  },

  noImage: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e9ecef',
    borderRadius: '8px',
  },

  noImageText: {
    fontSize: '12px',
    color: '#6c757d',
    textAlign: 'center',
  },

  infoCol: {
    padding: '0 0 0 16px',
  },

  productInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    minHeight: '100px',
    with: '100%',
    padding: '10px',
  },

  productDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    height: '100%',
    with: '100%',
  },

  productName: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#212529',
    marginBottom: '8px',
    lineHeight: '1.4',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'right',
  },

  productCode: {
    fontSize: '12px',
    color: '#6c757d',
    marginBottom: '8px',
  },

  weightContainer: {
    marginTop: 'auto',
  },

  weightBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#e9ecef',
    color: '#495057',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '500',
    textAlign: 'right',
  },

  weightValue: {
    fontWeight: '600',
    color: '#212529',
  },

  weightUnit: {
    fontSize: '12px',
    opacity: 0.8,
  },

  weightInfo: {
    marginTop: 'auto',
    textAlign: 'right',
  },

  weightText: {
    fontSize: '13px',
    color: '#6c757d',
    fontWeight: '400',
  },

  priceContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignItems: 'flex-end',
    minWidth: '120px',
    height: '100%',
    textAlign: 'right',
  },

  priceWrapper: {
    textAlign: 'right',
    display: 'flex',
    flexDirection: 'row',
    // alignItems: 'flex-end',
  },

  priceValue: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#01494b',
    lineHeight: '1.2',
    marginBottom: '2px',
  },

  priceUnit: {
    fontSize: '12px',
    color: '#6c757d',
    fontWeight: '400',
    marginInlineStart: '4px',
  },
};

// CSS for hover effects and responsive design
const productCardCSS = `
.product-card-info {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #ffffff;
}

.product-card-info:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  transform: translateY(-3px);
  border-color: #dee2e6;
}

.product-card-info img {
  transition: transform 0.3s ease;
}

.product-card-info:hover img {
  transform: scale(1.05);
}

/* Responsive Design */
@media (max-width: 576px) {
  .product-card-info .product-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .product-card-info .price-container {
    align-items: flex-start;
    min-width: auto;
    width: 100%;
  }
  
  .product-card-info .price-wrapper {
    align-items: flex-start;
  }
  
  .product-card-info h6 {
    font-size: 14px;
  }
  
  .product-card-info .price-value {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .product-card-info .image-container {
    height: 80px;
  }
  
  .product-card-info .product-info {
    min-height: 80px;
  }
}

/* RTL Support */
[dir="rtl"] .product-card-info .info-col {
  padding: 0 16px 0 0;
}

[dir="rtl"] .product-card-info .price-wrapper {
  align-items: flex-start;
  text-align: left;
}

/* Animation for loading states */
.product-card-info.loading {
  opacity: 0.7;
  pointer-events: none;
}

.product-card-info.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .product-card-info {
    background: #2d3748;
    border-color: #4a5568;
  }
  
  .product-card-info h6 {
    color: #f7fafc;
  }
  
  .product-card-info .weight-text,
  .product-card-info .price-unit {
    color: #a0aec0;
  }
  
  .product-card-info .weight-badge {
    background-color: #4a5568;
    color: #e2e8f0;
  }
  
  .product-card-info .no-image {
    background-color: #4a5568;
  }
  
  .product-card-info .no-image-text {
    color: #a0aec0;
  }
}
`;

// Inject CSS
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = productCardCSS;
  document.head.appendChild(styleElement);
}

export default ProductCard;
